import clsx from 'clsx'
import { ReactNode } from 'react'

import { Flex } from 'components/common/flex/Flex'

import styles from './Button.module.scss'

interface Props {
  text: string
  iconLeft?: ReactNode
  iconRight?: ReactNode
  variant?: 'primary' | 'secondary' | 'tertiary' | 'black' | 'outlined' | 'red'
  small?: boolean
  onClick?: () => void
  className?: string
  disabled?: boolean
}
export const Button = ({
  text,
  iconLeft,
  iconRight,
  variant = 'primary',
  small = false,
  onClick = () => {},
  className,
  disabled,
}: Props) => {
  return (
    <Flex
      className={clsx(styles.flexBaseWidth, styles[variant], small && styles.small, className, 'justify-center', {
        [styles.disabled]: disabled,
      })}
      inline
      align="center"
      gap={8}
      onClick={() => onClick()}
    >
      {iconLeft}
      <div>{text}</div>
      {iconRight}
    </Flex>
  )
}
